import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import RemoteAutocompleteWithSearch from '@components/form/RemoteAutocompleteWithSearch';
import {connect} from 'react-redux';
import { Products } from "@components/product";
import {Input} from '@components/form/Input';
import {NewProductContainer} from '@components/product/modals/new-product/new-product.container';
import combineStyles from '~/utils/styles';
import styles from '@components/orders/modals/new-order/styles';
import formStyles from '@style/form';
import ResponsiveComponent from '@components/form/ResponsiveComponent';
import InputAdornment from '@material-ui/core/InputAdornment';
import modalStyles from '@style/modal';
import AddCircleRoundedIcon from '@material-ui/icons/AddCircleRounded';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {SimpleDialog} from "@components/form/SimpleDialog";
import {LabelButton} from "@components/common/buttons/LabelButton";
import {TooltipButton} from "@components/common/buttons/TooltipButton";
import clsx from 'clsx'

class AddProductComponent extends React.Component {
    initState = {
        category_id: 0,
        variation: {},
        variationOption: null,
        amount: 1,
        price: 0,
        price_in: 0,
        prices: [],
        price_id: '',
        productSearchString: undefined,
        categorySearchString: undefined,
        comment: '',
        errors: {},
        currency: {
            code: '',
        },
    };

    state = {
        open: false,
        ...this.initState
    }

    processSelectedProduct = async ({value, label}) => {
        let variation = await this.props.getProductVariationDetails(value);
        let priceRow = variation.data.prices.filter((row) => {return row.group_id == this.props.priceGroupId});

        this.setState({
            variation: variation.data,
            currency: priceRow[0]?.group.currency,
            price: parseFloat(priceRow[0]?.price),
            price_in: parseFloat(variation.data.price_in),
            prices: variation.data.prices,
        });
    };

    productCreated = (product) => {
        let variationOptionLabel = `${product.id}: ${product.title}${product.main.barcode ? ' b/c:' + product.main.barcode  : ''}${product.main.sku ? ' sku:' + product.main.sku  : ''}`
        this.setState({
            ...this.state,
            category_id: product.category_id,
            variation: product.main,
            price: product.main.price,
            price_in: product.main.price_in,
            prices: product.main.prices,
            variationOption: {
                value: product.main.id,
                label: variationOptionLabel
            }
        });
    };

    componentDidUpdate(prevState, prevProps) {
        if (this.state.open != prevProps.open && this.props.variation) {
            let variationData = this.props.variation;
            variationData.price = variationData.original_price;
            this.setState({...this.props.variation});
        } else if (this.state.open != prevProps.open) {
            this.setState(this.initState);
        }
    }

    render() {
        let { classes } = this.props;

        return (
            <SimpleDialog
                fullWidth={true}
                maxWidth={'md'}
                open={this.state.open}
                dialogProps={{
                    onClick: e => e.stopPropagation(),
                }}
                onClose={(e) => {
                    this.setState({open: false})
                }}
                title={ this.props.variation
                    ? <ResponsiveComponent xs='Редактирование в заказе' sm='Редактирование товара в заказе'/>
                    : <ResponsiveComponent xs='Добавление в заказ' sm='Добавление нового товара в заказ'/>}
                icon={ this.props.variation
                    ? (<TooltipButton title="Редактировать"
                        icon={<EditOutlinedIcon color={'primary'} style={{cursor: 'pointer'}} />}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.setState({open: true})
                        }}
                    />)
                    : <ResponsiveComponent
                        xs={<LabelButton
                            title={'Добавить в заказ'}
                            icon={<AddCircleRoundedIcon color={'primary'}/>}
                            onClick={(e) => this.setState({open: true})}
                        />}
                        md={<AddCircleRoundedIcon
                            style={{cursor: 'pointer'}}
                            color={'primary'}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                this.setState({open: true})
                            }}
                        />}
                    />}
                actions={[
                    (<Button
                        disabled={isNaN(this.state.variation.id) || !Number.isInteger(this.state.amount) || this.state.amount < 1}
                        onClick={(e) => {
                            this.props.addProduct({
                                ...this.state.variation,
                                price: this.state.price,
                                price_in: this.state.price_in,
                                comment: this.state.comment,
                            }, this.state.amount);
                            this.setState({open: false});
                        }}
                        color="primary" variant="contained"
                    >
                        Сохранить
                    </Button>),
                ]}
            >
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={12}>
                        <RemoteAutocompleteWithSearch
                            name={'category_id'}
                            url={'/api/v1/categories/autocomplete'}
                            SearchString={this.state.categorySearchString}
                            value={this.state.category_id}
                            label="Категория"
                            onChange={(e, {value}) => this.setState({category_id: value, variation: {}})}
                            className={clsx([classes.input, classes.resetInputMarginTop])}
                            variant={'outlined'}
                            margin={'normal'}
                            size={'small'}
                            fullWidth
                        />

                        <div className={classes.productInput}>
                            <RemoteAutocompleteWithSearch
                                name={'product'}
                                url={'/api/v1/autocomplete/products?category_id=' + this.state.category_id}
                                SearchString={this.state.productSearchString}
                                value={this.state.variation.id}
                                label="Товар"
                                onChange={(e, option) => this.processSelectedProduct(option)}
                                key={this.state.category_id}
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                                disableClearable
                                disableEverQueryChangedProperty={!!!this.props.variation}
                                objectValue={this.state.variationOption}
                            />
                            <NewProductContainer
                                onSubmitRedirect={this.productCreated}
                                customOpenButton={<AddCircleRoundedIcon
                                    className={classes.input_icon}
                                    style={{paddingBottom: '8px', paddingTop: '5px'}}
                                    color={'primary'}
                                />}
                                disableVariationsCreation
                            />
                        </div>

                        <Grid container spacing={3} className={classes.addProductSubContainer}>
                            <Grid item xs={12} sm={4}>
                                <Input
                                    name={'amount'}
                                    value={this.state.amount}
                                    label={<ResponsiveComponent xs='Кол-во' sm='Количество'/>}
                                    onChange={({target: {value}}) => this.setState({amount: isNaN(parseInt(value)) ? '' : parseInt(value)})}
                                    type="number"
                                    min={1}
                                    max={9999}
                                    className={clsx([classes.input, classes.resetMarginBottom])}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Input
                                    name={'price'}
                                    value={this.state.price}
                                    label={<ResponsiveComponent xs='Продажа' sm='Цена продажи'/>}
                                    onChange={({target: {value}}) => this.setState({price: isNaN(parseInt(value)) ? '' : parseInt(value)})}
                                    type="number"
                                    className={clsx([classes.input, classes.resetMarginBottom])}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">{this.state?.currency?.code ?? ''}</InputAdornment>,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Input
                                    name={'price_in'}
                                    value={this.state.price_in || 0}
                                    label={<ResponsiveComponent xs='Закупка' sm='Цена закупки'/>}
                                    onChange={({target: {value}}) => this.setState({price_in: isNaN(parseInt(value)) ? '' : parseInt(value)})}
                                    type="number"
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">грн</InputAdornment>,
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Input
                            name={'comment'}
                            value={this.state.comment}
                            label={'Комментарий'}
                            onChange={({target: {value}}) => this.setState({comment: value})}
                            className={clsx([classes.input, classes.resetMarginBottom])}
                            variant={'outlined'}
                            margin={'normal'}
                            size={'small'}
                            fullWidth
                            multiline
                        />
                    </Grid>
                </Grid>
            </SimpleDialog>
        );
    }
}

const actions = {
    getProductVariationDetails: Products.actions.getProductVariationDetails,
};

export const AddProductModal = connect(null, actions)(withStyles(combineStyles(formStyles, modalStyles, styles))(AddProductComponent));
